import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getCategories, getGenre } from '../../../../services/CommonServices';
import EditProjectUI from './EditProjectUI';

const EditProject = ({ formik }) => {
    const dispatch = useDispatch();
    const { data: categories } = useSelector((state) => state.category);
    const { data: genres } = useSelector((state) => state.genre);
    const [selectedRelationData, setSelectedRelationData] = useState({
        artForm: {},
        genre: {},
        duration: { label: formik.values.duration, value: formik.values.duration },
        previouslyShowcased: { label: formik.values.previouslyShowcased ? "Yes" : "No", value: formik.values.previouslyShowcased }
    });
    useEffect(() => {
        dispatch(getCategories());
    }, []);
    useEffect(() => {
        if (categories?.length) {
            const matched = categories.find((s) => s._id == formik.values.artForm);
            if (matched) {
                setSelectedRelationData((prev) => ({
                    ...prev,
                    artForm: { label: matched.name, value: matched._id },
                }));
            }
        }
    }, [categories]);
    useEffect(() => {
        if (genres?.length) {
            const matched = genres.find((s) => s._id == formik.values.genre);
            if (matched) {
                setSelectedRelationData((prev) => ({
                    ...prev,
                    genre: { label: matched.name, value: matched._id },
                }));
            }
        }
    }, [genres]);
    useEffect(() => {
        if (selectedRelationData?.artForm?.value) {
            dispatch(getGenre({ category: selectedRelationData?.artForm?.value }))
        }
    }, [selectedRelationData?.artForm])
    return (
        <EditProjectUI
            formik={formik}
            selectedRelationData={selectedRelationData}
            setSelectedRelationData={setSelectedRelationData}
        />
    )
}

export default EditProject